export enum AppAssistanceRequestType{
  CONSULTANT = 'consultant',
  BACKOFFICE = 'backoffice'
}
